import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  background: (p) => p.palette.grey[200],
  p: 1.5,
  borderRadius: 1,
};

export const title: SxStyle = {
  fontSize: (p) => p.typography.caption.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const tabContent: SxStyle = {
  padding: (p) => p.spacing(1, 1, 0, 1),
  borderColor: (p) => p.palette.grey[300],
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: 0.5,
  background: (p) => p.palette.common.white,
  '.MuiButtonBase-root': {
    flex: 1,
    color: (p) => p.palette.primary[500],
  },
  '.MuiTabs-indicator': {
    background: (p) => p.palette.primary[500],
  },
  '.MuiTabPanel-root': {
    p: 0,
  },
};

export const textfield: SxStyle = {
  flex: 1,
  width: '100%',
  '.MuiInputBase-root': {
    borderRadius: 0.5,
  },
  input: {
    borderRadius: 0.5,
    background: (p) => p.palette.common.white,
    overflow: 'hidden',
    fontSize: (p) => p.typography.caption.fontSize,
  },
};
